"use strict";require("./array");